'use client';

import { c as _c } from "react/compiler-runtime";
export function NuggetStat(t0) {
  const $ = _c(12);
  const {
    stat
  } = t0;
  let t1;
  if ($[0] !== stat) {
    t1 = stat.split(" ");
    $[0] = stat;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let labelParts;
  let value;
  if ($[2] !== t1) {
    [value, ...labelParts] = t1;
    $[2] = t1;
    $[3] = labelParts;
    $[4] = value;
  } else {
    labelParts = $[3];
    value = $[4];
  }
  const label = labelParts.join(" ");
  let t2;
  if ($[5] !== value) {
    t2 = <p className="text-5xl sm:text-6xl">{value}</p>;
    $[5] = value;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== label) {
    t3 = label && <p className="mt-2 text-lg tracking-wide uppercase sm:text-xl">{label}</p>;
    $[7] = label;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <div className="font-sans leading-none font-black text-[#fff4df]">{t2}{t3}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}